Ext.define('SA.view.RelatedDataReportGrid', {
    alias: 'widget.related-data-report-grid',
    extend: 'SA.view.ReportGrid',

    listeners: {
        'cell:click': function(grid, td, data, column) {
            var location = column.dataIndex,
                variable = data.id;

            if (location === 'name') {
                grid.showRowMenu(td, variable);
            }
            else {
                grid.showCellMenu(td, variable, location);
            }
        },

        'cell:mouseout': function(grid, td) {
            Ext.fly(td).removeCls('sa-grid-cell-over');
        },

        'cell:mouseover': function(grid, td) {
            Ext.fly(td).addCls('sa-grid-cell-over');
        },

        'column:click': function(grid, el, column) {
            grid.showColumnMenu(el, column.dataIndex);
        },

        'column:mouseout': function(grid, td) {
            Ext.fly(td).removeCls('sa-grid-cell-over');
        },

        'column:mouseover': function(grid, td) {
            Ext.fly(td).addCls('sa-grid-cell-over');
        }
    },

    plugins: [{
        ptype: 'sa-grid-column-drag-reorder',

        afterMove(oldIndex, newIndex) {
            var grid = this.cmp,
                report = grid.projectView;

            report.moveLocation(oldIndex, newIndex);

            report.save();
        }
    }],

    initComponent() {
        var reportModel = this.projectView;

        this.addCls('sa-related-data-report-grid');

        this.columns = this.buildColumns();
        this.data = [];

        this.callParent();

        this.refreshData();

        this.mon(reportModel, {
            buffer: 10,
            scope: this,

            'change:attribute': this.onChangeAttributes,
            'change:attributeTypeFilter': this.onChangeAttributeTypeFilter,
            'change:location': this.onChangeLocations,
            'change:sort': this.onChangeSort
        });

        this.mon(SA.data.LocationAliases, {
            buffer: 10,
            scope: this,

            'change': this.onChangeAlias
        });
    },

    buildColumns() {
        var reportModel = this.projectView,
            locationIds = reportModel.getLocations(),
            locations = SA.data.LocationsCache.get(locationIds),
            sortLocation = reportModel.getSortLocation(),
            sortCls = 'sa-report-grid-sorted-' + reportModel.getSortDirection(),
            columns = [{
                cls: sortLocation ? '' : sortCls,
                dataIndex: 'name',
                encodeCells: false,
                forceRender: true,
                locked: true,
                text: 'Data Variable',
                width: 200
            }];

        locations.forEach((location, index) => {
            var locationId = locationIds[index];

            columns.push({
                align: 'right',
                autoWidth: 215,
                cls: locationId === sortLocation ? sortCls : '',
                contentWidth: true,
                dataIndex: locationId,
                encodeText: false,
                text: Ext.util.Format.locationRenderer(location)
            });
        });

       return columns;
    },

    onChangeAlias() {
        this.refreshColumns();
    },

    onChangeAttributeTypeFilter() {
        this.refreshData();
    },

    onChangeAttributes() {
        this.refreshData();
        this.refreshColumns();
    },

    onChangeLocations() {
        this.refreshColumns();
        this.refreshData();
    },

    onChangeSort() {
        this.refreshColumns();
        this.refreshData();
    },

    refreshColumns() {
        this.setColumns(this.buildColumns());
    },

    refreshData() {
        var oldData = this.data,
            reportModel = this.projectView,
            dataMap = reportModel.getReportData({fn: this.refreshData, scope: this}),
            attributeIds = reportModel.getRelatedAttributes(this.refreshData, this),
            Attributes = SA.data.AttributesCache,
            attributes = Attributes.get(attributeIds, this.refreshData, this),
            locationSeries = reportModel.getLocations(),
            sortLocation = reportModel.getSortLocation(),
            sortValues = sortLocation && dataMap[sortLocation],
            sortMultiplier = reportModel.getSortDirection() === 'asc' ? 1 : -1,
            rowsMap = {},
            data = [],
            isLoading = false,
            hasData = false;

        oldData.forEach(row => {
            rowsMap[row.id] = row;
        });

        attributes.forEach((attribute, index) => {
            var attributeId = attributeIds[index],
                row = rowsMap[attributeId],
                format = attribute && attribute.formatString;

            if (!row) {
                row = {id: attributeId};
            }

            if (attribute) {
                row.name = this.getHeaderHtmlForAttribute(attribute);
            }
            else {
                isLoading = true;
            }

            locationSeries.forEach(locationId => {
                var value = dataMap[locationId][attributeId];

                if (format && typeof value !== 'undefined') {
                    value = Attributes.formatValue(value, format);
                    hasData = true;
                }
                else {
                    isLoading = true;
                }

                row[locationId] = value || '';
            });

            data.push(row);
        });

        this.isLoading = isLoading;

        data.sort((row1, row2) => {
            if (!sortValues) {
                return naturalOrder();
            }

            var value1 = sortValues[row1.id],
                value2 = sortValues[row2.id];

            if (value1 === value2) {
                return naturalOrder();
            }

            if (value1 == null) {
                return 1;
            }

            if (value2 == null) {
                return -1;
            }

            return sortMultiplier * (value1 - value2);

            function naturalOrder() {
                return attributeIds.indexOf(row1.id) - attributeIds.indexOf(row2.id);
            }
        });

        this.setData(data);
        this.setLoading(isLoading && !hasData);

        this.ifCls(isLoading && hasData, 'sa-report-grid-empty-cell-loading');
    },

    showCellMenu(el, attributeId, locationSeries) {
        this.showMenu(el, [
            {
                xtype: 'menu-attribute-caption'
            }, {
                xtype: 'menu-location-caption'
            }, {
                xtype: 'menu-create-map'
            }, {
                xtype: 'menu-create-ranking'
            }
        ], {attribute: attributeId, location: locationSeries});
    },

    showColumnMenu(el, locationSeries) {
        var grid = this,
            items = [{xtype: 'menu-location-caption'}],
            projectView = grid.projectView;

        if (locationSeries === 'name') {
            items.push({
                disabled: grid.isLoading,
                text: 'Sort by data variables',

                handler() {
                    projectView.setSort(null);
                }
            });
        }
        else {
            items.push(
                {
                    xtype: 'menu-add-remove-favorite-location'
                }, {
                    xtype: 'menu-set-location-alias'
                }, {
                    xtype: 'menu-remove-location'
                }
            );

            if (projectView.getSortLocation() === locationSeries) {
                items.push({
                    text: 'Reverse sort order',

                    handler() {
                        projectView.setSort(locationSeries, projectView.getSortDirection() === 'desc' ? 'asc' : 'desc');
                        projectView.save();
                    }
                });
            }
            else {
                items.push(
                    {
                        disabled: grid.isLoading,
                        text: 'Sort, smallest to largest',

                        handler() {
                            projectView.setSort(locationSeries, 'asc');
                        }
                    }, {
                        disabled: grid.isLoading,
                        text: 'Sort, largest to smallest',

                        handler() {
                            projectView.setSort(locationSeries, 'desc');
                        }
                    }
                );
            }
        }

        grid.showMenu(el, items, {location: locationSeries});
    },

    showRowMenu(el, attributeId) {
        this.showMenu(el, [
            {
                xtype: 'menu-attribute-caption'
            }, {
                xtype: 'menu-add-remove-favorite-attribute'
            }, {
                xtype: 'menu-view-attribute-metadata'
            }, {
                xtype: 'menu-open-data-folder'
            }, {
                xtype: 'menu-create-bar-chart'
            }
        ], {attribute: attributeId});
    }
});
